/**
 * Created by ws7 on 2017/6/12.
 */

export const getSnaps = 'snap/getSnaps';
export const deleteSnaps = 'snap/deleteSnaps';
export const rollbackSnaps = 'snap/rollbackSnaps';
export const createSnaps = 'snap/createSnaps';
export const ModifyLocalVolumeSnapshot = 'snap/ModifyLocalVolumeSnapshot';
export const getAllSnaps = 'snap/getAllSnaps';

export const DescribeSnapshotUsageHistory = 'snap/DescribeSnapshotUsageHistory';
export const DescribeSnapshotChains = 'snap/DescribeSnapshotChains';
export const DescribeSnapshotsOfChain = 'snap/DescribeSnapshotsOfChain';
export const DescribeSnapshotChainTotalSize = 'snap/DescribeSnapshotChainTotalSize';


export const getDataDiskSnaps = 'snap/getDataDiskSnaps';
export const DescribeSnapshots = 'snap/DescribeSnapshots';

export const CopySnapshot = 'snap/CopySnapshot';
export const ModifySnapshotScheduledTime = 'snap/ModifySnapshotScheduledTime';
export const DescribeLocalVolumeSnapshots = 'snap/DescribeLocalVolumeSnapshots';
